<template>
    <div class="sizeChartContainer">
        <div v-if="vendor === 'A4'">
            <div class="sizeChart">
                <table>
                    <thead>
                        <tr>
                            <th>Gender</th>
                            <th>XXS</th>
                            <th>XS</th>
                            <th>S</th>
                            <th>M</th>
                            <th>L</th>
                            <th>XL</th>
                            <th>2XL</th>
                            <th>3XL</th>
                            <th>4XL</th>
                            <th>5XL</th>
                            <th>6XL</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Men’s T-Shirt (Chest)</td>
                            <td></td>
                            <td>38-40”</td>
                            <td>40-42”</td>
                            <td>42-44”</td>
                            <td>45-47”</td>
                            <td>48-50”</td>
                            <td>51-53”</td>
                            <td>54-56”</td>
                            <td>57-59”</td>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>Youth T-Shirt (Chest)</td>
                            <td>24-26”</td>
                            <td>28-32”</td>
                            <td>33-35”</td>
                            <td>36-37”</td>
                            <td>38-39”</td>
                            <td>40-41”</td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>Men’s (Waist)</td>
                            <td></td>
                            <td>23-25”</td>
                            <td>25-28”</td>
                            <td>28-30”</td>
                            <td>30-34”</td>
                            <td>34-38”</td>
                            <td>38-40”</td>
                            <td>40-42”</td>
                            <td>42-44”</td>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>Youth (Waist)</td>
                            <td></td>
                            <td>21”</td>
                            <td>22”</td>
                            <td>24”</td>
                            <td>26”</td>
                            <td>28”</td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div v-if="vendor === 'Alstyle'">
            <div class="sizeChart">
                <table>
                    <thead>
                        <tr>
                            <th>Gender</th>
                            <th>XXS</th>
                            <th>XS</th>
                            <th>S</th>
                            <th>M</th>
                            <th>L</th>
                            <th>XL</th>
                            <th>2XL</th>
                            <th>3XL</th>
                            <th>4XL</th>
                            <th>5XL</th>
                            <th>6XL</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Men’s (Chest)</td>
                            <td></td>
                            <td></td>
                            <td>34-36”</td>
                            <td>38-40”</td>
                            <td>42-44”</td>
                            <td>46-48”</td>
                            <td>50-52”</td>
                            <td>54-56”</td>
                            <td>58-60”</td>
                            <td>62-66”</td>
                            <td></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div v-if="vendor === 'American Apparel'">
            <div class="sizeChart">
                <table>
                    <thead>
                        <tr>
                            <th>Gender</th>
                            <th>XXS</th>
                            <th>XS</th>
                            <th>S</th>
                            <th>M</th>
                            <th>L</th>
                            <th>XL</th>
                            <th>2XL</th>
                            <th>3XL</th>
                            <th>4XL</th>
                            <th>5XL</th>
                            <th>6XL</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Unisex(Chest)</td>
                            <td>29-31”</td>
                            <td>30-32”</td>
                            <td>34-36”</td>
                            <td>38-40”</td>
                            <td>42-44”</td>
                            <td>46-48”</td>
                            <td>48-50”</td>
                            <td>50-52”</td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div v-if="vendor === 'Anvil'">
            <div class="sizeChart">
                <table>
                    <thead>
                        <tr>
                            <th>Gender</th>
                            <th>XXS</th>
                            <th>XS</th>
                            <th>S</th>
                            <th>M</th>
                            <th>L</th>
                            <th>XL</th>
                            <th>2XL</th>
                            <th>3XL</th>
                            <th>4XL</th>
                            <th>5XL</th>
                            <th>6XL</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Men’s (Chest)</td>
                            <td></td>
                            <td></td>
                            <td>34-36”</td>
                            <td>38-40”</td>
                            <td>42-44”</td>
                            <td>46-48”</td>
                            <td>50-52”</td>
                            <td>54-56”</td>
                            <td>58-60”</td>
                            <td>64”</td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>Junior Women’s (Size)</td>
                            <td></td>
                            <td></td>
                            <td>0-2</td>
                            <td>4-6</td>
                            <td>8-10</td>
                            <td>12-14</td>
                            <td>16-18</td>
                            <td>18-20</td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>Women’s (Size)</td>
                            <td></td>
                            <td>0-2</td>
                            <td>4-6</td>
                            <td>8-10</td>
                            <td>12-14</td>
                            <td>18-20</td>
                            <td>20-22</td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div v-if="vendor === 'Bayside'">
            <div class="sizeChart">
                <table>
                    <thead>
                        <tr>
                            <th>Gender</th>
                            <th>XXS</th>
                            <th>XS</th>
                            <th>S</th>
                            <th>M</th>
                            <th>L</th>
                            <th>XL</th>
                            <th>2XL</th>
                            <th>3XL</th>
                            <th>4XL</th>
                            <th>5XL</th>
                            <th>6XL</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Adult (Chest)</td>
                            <td></td>
                            <td></td>
                            <td>36”</td>
                            <td>40”</td>
                            <td>44”</td>
                            <td>48”</td>
                            <td>52”</td>
                            <td>56”</td>
                            <td>60”</td>
                            <td>64”</td>
                            <td></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div v-if="vendor === 'Bella + Canvas'">
            <div class="sizeChart">
                <table>
                    <thead>
                        <tr>
                            <th>Gender</th>
                            <th>XXS</th>
                            <th>XS</th>
                            <th>S</th>
                            <th>M</th>
                            <th>L</th>
                            <th>XL</th>
                            <th>2XL</th>
                            <th>3XL</th>
                            <th>4XL</th>
                            <th>5XL</th>
                            <th>6XL</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Men’s/Unisex (Chest)</td>
                            <td></td>
                            <td>31-34”</td>
                            <td>34-37”</td>
                            <td>38-41”</td>
                            <td>42-45”</td>
                            <td>46-49”</td>
                            <td>50-53”</td>
                            <td>54-57”</td>
                            <td>58-61”</td>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>Women’s Jersey/Rib (Size)</td>
                            <td></td>
                            <td></td>
                            <td>2-4</td>
                            <td>6-8</td>
                            <td>8-10</td>
                            <td>10-14</td>
                            <td>14-18</td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>Women’s Relaxed (Size)</td>
                            <td></td>
                            <td></td>
                            <td>2-6</td>
                            <td>6-10</td>
                            <td>10-14</td>
                            <td>14-18</td>
                            <td>18-22</td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>Women’s Flowy (Size)</td>
                            <td></td>
                            <td>0-2</td>
                            <td>2-4</td>
                            <td>6-10</td>
                            <td>10-14</td>
                            <td>14-18</td>
                            <td>18-20</td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>Youth (Size)</td>
                            <td></td>
                            <td></td>
                            <td>6-8</td>
                            <td>10-12</td>
                            <td>14-16</td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div v-if="vendor === 'Berne'">
            <div class="sizeChart">
                <table>
                    <thead>
                        <tr>
                            <th>Gender</th>
                            <th>XXS</th>
                            <th>XS</th>
                            <th>S</th>
                            <th>M</th>
                            <th>L</th>
                            <th>XL</th>
                            <th>2XL</th>
                            <th>3XL</th>
                            <th>4XL</th>
                            <th>5XL</th>
                            <th>6XL</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Men’s (Chest)</td>
                            <td></td>
                            <td></td>
                            <td>36-38”</td>
                            <td>40-42”</td>
                            <td>44-46”</td>
                            <td>48-50”</td>
                            <td>52-54”</td>
                            <td>56-58”</td>
                            <td>60-62”</td>
                            <td></td>
                            <td></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div v-if="vendor === 'Burnside'">
            <div class="sizeChart">
                <table>
                    <thead>
                        <tr>
                            <th>Gender</th>
                            <th>XXS</th>
                            <th>XS</th>
                            <th>S</th>
                            <th>M</th>
                            <th>L</th>
                            <th>XL</th>
                            <th>2XL</th>
                            <th>3XL</th>
                            <th>4XL</th>
                            <th>5XL</th>
                            <th>6XL</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Men’s (Chest)</td>
                            <td></td>
                            <td></td>
                            <td>38-40”</td>
                            <td>41-43”</td>
                            <td>44-46”</td>
                            <td>47-49”</td>
                            <td>50-52”</td>
                            <td>54-56”</td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>Men’s (Waist)</td>
                            <td></td>
                            <td></td>
                            <td>32”</td>
                            <td>34”</td>
                            <td>36”</td>
                            <td>38”</td>
                            <td>40”</td>
                            <td>42”</td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div v-if="vendor === 'Champion'">
            <div class="sizeChart">
                <table>
                    <thead>
                        <tr>
                            <th>Gender</th>
                            <th>XXS</th>
                            <th>XS</th>
                            <th>S</th>
                            <th>M</th>
                            <th>L</th>
                            <th>XL</th>
                            <th>2XL</th>
                            <th>3XL</th>
                            <th>4XL</th>
                            <th>5XL</th>
                            <th>6XL</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Men’s (Chest)</td>
                            <td></td>
                            <td>30-32”</td>
                            <td>34-36”</td>
                            <td>38-40”</td>
                            <td>42-44”</td>
                            <td>46-48”</td>
                            <td>50-52”</td>
                            <td>54-56”</td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>Men’s (Waist)</td>
                            <td></td>
                            <td>24-26”</td>
                            <td>28-30”</td>
                            <td>32-34”</td>
                            <td>36-38”</td>
                            <td>40-42”</td>
                            <td>44-46”</td>
                            <td>48-50”</td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div v-if="vendor === 'Code Five'">
            <div class="sizeChart">
                <table>
                    <thead>
                        <tr>
                            <th>Gender</th>
                            <th>XXS</th>
                            <th>XS</th>
                            <th>S</th>
                            <th>M</th>
                            <th>L</th>
                            <th>XL</th>
                            <th>2XL</th>
                            <th>3XL</th>
                            <th>4XL</th>
                            <th>5XL</th>
                            <th>6XL</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Men’s (Chest)</td>
                            <td></td>
                            <td></td>
                            <td>34-36”</td>
                            <td>38-40”</td>
                            <td>42-44”</td>
                            <td>46-48”</td>
                            <td>50-52”</td>
                            <td>54-56”</td>
                            <td>58-60”</td>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>Youth (Chest)</td>
                            <td></td>
                            <td>26-28”</td>
                            <td>28-32”</td>
                            <td>32-36”</td>
                            <td>36-38”</td>
                            <td>38-40”</td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div v-if="vendor === 'Comfort Colors'">
            <div class="sizeChart">
                <table>
                    <thead>
                        <tr>
                            <th>Gender</th>
                            <th>XXS</th>
                            <th>XS</th>
                            <th>S</th>
                            <th>M</th>
                            <th>L</th>
                            <th>XL</th>
                            <th>2XL</th>
                            <th>3XL</th>
                            <th>4XL</th>
                            <th>5XL</th>
                            <th>6XL</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Men’s (Chest)</td>
                            <td></td>
                            <td></td>
                            <td>37-45.5”</td>
                            <td>41-47.5”</td>
                            <td>45-50.5”</td>
                            <td>49-53”</td>
                            <td>53-56”</td>
                            <td>56”</td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>Women’s (Size)</td>
                            <td></td>
                            <td>0-2</td>
                            <td>4-6</td>
                            <td>8-10</td>
                            <td>12-14</td>
                            <td>16-18</td>
                            <td>20-22</td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>Youth (Size)</td>
                            <td></td>
                            <td>2-4</td>
                            <td>6-8</td>
                            <td>10-12</td>
                            <td>14-16</td>
                            <td>18-20</td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div v-if="vendor === 'ComfortWash'">
            <div class="sizeChart">
                <table>
                    <thead>
                        <tr>
                            <th>Gender</th>
                            <th>XXS</th>
                            <th>XS</th>
                            <th>S</th>
                            <th>M</th>
                            <th>L</th>
                            <th>XL</th>
                            <th>2XL</th>
                            <th>3XL</th>
                            <th>4XL</th>
                            <th>5XL</th>
                            <th>6XL</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Men’s (Chest)</td>
                            <td></td>
                            <td>30-32”</td>
                            <td>34-36”</td>
                            <td>38-40”</td>
                            <td>42-44”</td>
                            <td>46-48”</td>
                            <td>50-52”</td>
                            <td>54-56”</td>
                            <td>58-60”</td>
                            <td>62-64”</td>
                            <td>66-68”</td>
                        </tr>
                        <tr>
                            <td>Women’s (Size)</td>
                            <td></td>
                            <td>0-2</td>
                            <td>4-6</td>
                            <td>8-10</td>
                            <td>12-14</td>
                            <td>16-18</td>
                            <td>20-22</td>
                            <td>24-26</td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>Unisex (Chest)</td>
                            <td></td>
                            <td>30-32”</td>
                            <td>34-36”</td>
                            <td>38-40”</td>
                            <td>42-44”</td>
                            <td>46-48”</td>
                            <td>50-52”</td>
                            <td>54-56”</td>
                            <td>58-60”</td>
                            <td>62-64”</td>
                            <td>66-68”</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div v-if="vendor === 'Core365'">
            <div class="sizeChart">
                <table>
                    <thead>
                        <tr>
                            <th>Gender</th>
                            <th>XXS</th>
                            <th>XS</th>
                            <th>S</th>
                            <th>M</th>
                            <th>L</th>
                            <th>XL</th>
                            <th>2XL</th>
                            <th>3XL</th>
                            <th>4XL</th>
                            <th>5XL</th>
                            <th>6XL</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Men’s (Neck/Collar)</td>
                            <td></td>
                            <td>13.5-14”</td>
                            <td>14.5-15”</td>
                            <td>15.5-16”</td>
                            <td>16.5-17”</td>
                            <td>17.5-18”</td>
                            <td>18.5-19”</td>
                            <td>19.5-20”</td>
                            <td>20.5-21”</td>
                            <td>21.5-22”</td>
                            <td>22.5-23”</td>
                        </tr>
                        <tr>
                            <td>Men’s (Chest)</td>
                            <td></td>
                            <td>32-34”</td>
                            <td>35-38”</td>
                            <td>39-41”</td>
                            <td>42-45”</td>
                            <td>46-49”</td>
                            <td>50-52”</td>
                            <td>53-56”</td>
                            <td>57-60”</td>
                            <td>61-64”</td>
                            <td>65-68”</td>
                        </tr>
                        <tr>
                            <td>Men’s (Waist)</td>
                            <td></td>
                            <td>26-28”</td>
                            <td>29-31”</td>
                            <td>32-34”</td>
                            <td>35-37”</td>
                            <td>38-41”</td>
                            <td>42-44”</td>
                            <td>45-47”</td>
                            <td>48-50”</td>
                            <td>51-53”</td>
                            <td>54-56”</td>
                        </tr>
                        <tr>
                            <td>Women’s (Chest)</td>
                            <td></td>
                            <td>31-32”</td>
                            <td>33-35”</td>
                            <td>36-38”</td>
                            <td>39-42”</td>
                            <td>43-45”</td>
                            <td>46-49”</td>
                            <td>50-53”</td>
                            <td>54-57”</td>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>Women’s (Waist)</td>
                            <td></td>
                            <td>23-24”</td>
                            <td>25-27”</td>
                            <td>28-30”</td>
                            <td>31-32”</td>
                            <td>33-35”</td>
                            <td>36-38”</td>
                            <td>39-41”</td>
                            <td>42-44”</td>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>Women’s (Hip)</td>
                            <td></td>
                            <td>33-34”</td>
                            <td>35-37”</td>
                            <td>38-40”</td>
                            <td>41-42”</td>
                            <td>43-45”</td>
                            <td>46-48”</td>
                            <td>49-51”</td>
                            <td>52-54”</td>
                            <td></td>
                            <td></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div v-if="vendor === 'Devon&Jones'">
            <div class="sizeChart">
                <table>
                    <thead>
                        <tr>
                            <th>Gender</th>
                            <th>XXS</th>
                            <th>XS</th>
                            <th>S</th>
                            <th>M</th>
                            <th>L</th>
                            <th>XL</th>
                            <th>2XL</th>
                            <th>3XL</th>
                            <th>4XL</th>
                            <th>5XL</th>
                            <th>6XL</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Men’s (Neck/Collar)</td>
                            <td></td>
                            <td>13.5-14”</td>
                            <td>14.5-15”</td>
                            <td>15.5-16”</td>
                            <td>16.5-17”</td>
                            <td>17.5-18”</td>
                            <td>18.5-19”</td>
                            <td>19.5-20”</td>
                            <td>20.5-21”</td>
                            <td>21.5-22”</td>
                            <td>22.5-23”</td>
                        </tr>
                        <tr>
                            <td>Men’s (Chest)</td>
                            <td></td>
                            <td>32-34”</td>
                            <td>35-38”</td>
                            <td>39-41”</td>
                            <td>42-45”</td>
                            <td>46-49”</td>
                            <td>50-52”</td>
                            <td>53-56”</td>
                            <td>57-60”</td>
                            <td>61-64”</td>
                            <td>65-68”</td>
                        </tr>
                        <tr>
                            <td>Men’s (Waist)</td>
                            <td></td>
                            <td>26-28”</td>
                            <td>29-31”</td>
                            <td>32-34”</td>
                            <td>35-37”</td>
                            <td>38-41”</td>
                            <td>42-44”</td>
                            <td>45-47”</td>
                            <td>48-50”</td>
                            <td>51-53”</td>
                            <td>54-56”</td>
                        </tr>
                        <tr>
                            <td>Women’s (Chest)</td>
                            <td></td>
                            <td>31-32”</td>
                            <td>33-35”</td>
                            <td>36-38”</td>
                            <td>39-42”</td>
                            <td>43-45”</td>
                            <td>46-49”</td>
                            <td>50-53”</td>
                            <td>54-57”</td>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>Women’s (Waist)</td>
                            <td></td>
                            <td>23-24”</td>
                            <td>25-27”</td>
                            <td>28-30”</td>
                            <td>31-32”</td>
                            <td>33-35”</td>
                            <td>36-38”</td>
                            <td>39-41”</td>
                            <td>42-44”</td>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>Women’s (Hip)</td>
                            <td></td>
                            <td>33-34”</td>
                            <td>35-37”</td>
                            <td>38-40”</td>
                            <td>41-42”</td>
                            <td>43-45”</td>
                            <td>46-48”</td>
                            <td>49-51”</td>
                            <td>52-54”</td>
                            <td></td>
                            <td></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div v-if="vendor === 'Dickies'">
            <div class="sizeChart">
                <table>
                    <thead>
                        <tr>
                            <th>Gender</th>
                            <th>XXS</th>
                            <th>XS</th>
                            <th>S</th>
                            <th>M</th>
                            <th>L</th>
                            <th>XL</th>
                            <th>2XL</th>
                            <th>3XL</th>
                            <th>4XL</th>
                            <th>5XL</th>
                            <th>6XL</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Men’s (Chest)</td>
                            <td></td>
                            <td></td>
                            <td>34-36”</td>
                            <td>38-40”</td>
                            <td>42-44”</td>
                            <td>46-48”</td>
                            <td>50-52”</td>
                            <td>54-56”</td>
                            <td>58-60”</td>
                            <td>62-64”</td>
                            <td></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div v-if="vendor === 'Dri-Duck'">
            <div class="sizeChart">
                <table>
                    <thead>
                        <tr>
                            <th>Gender</th>
                            <th>XXS</th>
                            <th>XS</th>
                            <th>S</th>
                            <th>M</th>
                            <th>L</th>
                            <th>XL</th>
                            <th>2XL</th>
                            <th>3XL</th>
                            <th>4XL</th>
                            <th>5XL</th>
                            <th>6XL</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Men’s (Chest)</td>
                            <td></td>
                            <td></td>
                            <td>34-36”</td>
                            <td>38-40”</td>
                            <td>42-44”</td>
                            <td>46-48”</td>
                            <td>50-52”</td>
                            <td>54-56”</td>
                            <td>58-60”</td>
                            <td>62-64”</td>
                            <td>66-68”</td>
                        </tr>
                        <tr>
                            <td>Women’s (Size)</td>
                            <td></td>
                            <td></td>
                            <td>4-6</td>
                            <td>8-10</td>
                            <td>12-14</td>
                            <td>16-18</td>
                            <td>20-22</td>
                            <td>24-26</td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div v-if="vendor === 'Econscious'">
            <div class="sizeChart">
                <table>
                    <thead>
                        <tr>
                            <th>Gender</th>
                            <th>XXS</th>
                            <th>XS</th>
                            <th>S</th>
                            <th>M</th>
                            <th>L</th>
                            <th>XL</th>
                            <th>2XL</th>
                            <th>3XL</th>
                            <th>4XL</th>
                            <th>5XL</th>
                            <th>6XL</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Men’s (Chest)</td>
                            <td></td>
                            <td>33-36”</td>
                            <td>35.25-40”</td>
                            <td>38.25-44”</td>
                            <td>41.25-48”</td>
                            <td>44.25-51”</td>
                            <td>47.25-54”</td>
                            <td>57”</td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>Women’s (Chest)</td>
                            <td></td>
                            <td></td>
                            <td>33-35”</td>
                            <td>35-38”</td>
                            <td>38.5-42”</td>
                            <td>42-43.5”</td>
                            <td>45-47.5”</td>
                            <td>51”</td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div v-if="vendor === 'Extreme'">
            <div class="sizeChart">
                <table>
                    <thead>
                        <tr>
                            <th>Gender</th>
                            <th>XXS</th>
                            <th>XS</th>
                            <th>S</th>
                            <th>M</th>
                            <th>L</th>
                            <th>XL</th>
                            <th>2XL</th>
                            <th>3XL</th>
                            <th>4XL</th>
                            <th>5XL</th>
                            <th>6XL</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Men’s (Neck/Collar)</td>
                            <td></td>
                            <td>13.5-14”</td>
                            <td>14.5-15”</td>
                            <td>15.5-16”</td>
                            <td>16.5-17”</td>
                            <td>17.5-18”</td>
                            <td>18.5-19”</td>
                            <td>19.5-20”</td>
                            <td>20.5-21”</td>
                            <td>21.5-22”</td>
                            <td>22.5-23”</td>
                        </tr>
                        <tr>
                            <td>Men’s (Chest)</td>
                            <td></td>
                            <td>32-34”</td>
                            <td>35-38”</td>
                            <td>39-41”</td>
                            <td>42-45”</td>
                            <td>46-49”</td>
                            <td>50-52”</td>
                            <td>53-56”</td>
                            <td>57-60”</td>
                            <td>61-64”</td>
                            <td>65-68”</td>
                        </tr>
                        <tr>
                            <td>Men’s (Waist)</td>
                            <td></td>
                            <td>26-28”</td>
                            <td>29-31”</td>
                            <td>32-34”</td>
                            <td>35-37”</td>
                            <td>38-41”</td>
                            <td>42-44”</td>
                            <td>45-47”</td>
                            <td>48-50”</td>
                            <td>51-53”</td>
                            <td>54-56”</td>
                        </tr>
                        <tr>
                            <td>Women’s (Chest)</td>
                            <td></td>
                            <td>31-32”</td>
                            <td>33-35”</td>
                            <td>36-38”</td>
                            <td>39-42”</td>
                            <td>43-45”</td>
                            <td>46-49”</td>
                            <td>50-53”</td>
                            <td>54-57”</td>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>Women’s (Waist)</td>
                            <td></td>
                            <td>23-24”</td>
                            <td>25-27”</td>
                            <td>28-30”</td>
                            <td>31-32”</td>
                            <td>33-35”</td>
                            <td>36-38”</td>
                            <td>39-41”</td>
                            <td>42-44”</td>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>Women’s (Hip)</td>
                            <td></td>
                            <td>33-34”</td>
                            <td>35-37”</td>
                            <td>38-40”</td>
                            <td>41-42”</td>
                            <td>43-45”</td>
                            <td>46-48”</td>
                            <td>49-51”</td>
                            <td>52-54”</td>
                            <td></td>
                            <td></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div v-if="vendor === 'Fruit of the Loom'">
            <div class="sizeChart">
                <table>
                    <thead>
                        <tr>
                            <th>Gender</th>
                            <th>XXS</th>
                            <th>XS</th>
                            <th>S</th>
                            <th>M</th>
                            <th>L</th>
                            <th>XL</th>
                            <th>2XL</th>
                            <th>3XL</th>
                            <th>4XL</th>
                            <th>5XL</th>
                            <th>6XL</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Men’s (Chest)</td>
                            <td></td>
                            <td></td>
                            <td>34-36”</td>
                            <td>38-40”</td>
                            <td>42-44”</td>
                            <td>46-48”</td>
                            <td>50-52”</td>
                            <td>54-56”</td>
                            <td>58-60”</td>
                            <td>62-64”</td>
                            <td>66-68”</td>
                        </tr>
                        <tr>
                            <td>Women’s (Size)</td>
                            <td></td>
                            <td></td>
                            <td>4-6</td>
                            <td>8-10</td>
                            <td>12-14</td>
                            <td>16-18</td>
                            <td>20-22</td>
                            <td>24-26</td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div v-if="vendor === 'Gildan'">
            <div class="sizeChart">
                <table>
                    <thead>
                        <tr>
                            <th>Gender</th>
                            <th>XXS</th>
                            <th>XS</th>
                            <th>S</th>
                            <th>M</th>
                            <th>L</th>
                            <th>XL</th>
                            <th>2XL</th>
                            <th>3XL</th>
                            <th>4XL</th>
                            <th>5XL</th>
                            <th>6XL</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Men’s (Chest)</td>
                            <td></td>
                            <td></td>
                            <td>34-36”</td>
                            <td>38-40”</td>
                            <td>42-44”</td>
                            <td>46-50”</td>
                            <td>50-52”</td>
                            <td>54-56”</td>
                            <td>58-60”</td>
                            <td>62-64”</td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>Women’s (Size)</td>
                            <td></td>
                            <td>0-2</td>
                            <td>4-6</td>
                            <td>8-10</td>
                            <td>12-14</td>
                            <td>18-20</td>
                            <td>20-22</td>
                            <td>24-26</td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>Junior Women’s (Size)</td>
                            <td></td>
                            <td></td>
                            <td>0-2</td>
                            <td>4-6</td>
                            <td>8-10</td>
                            <td>12-14</td>
                            <td>16-18</td>
                            <td>18-20</td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>Youth (Size)</td>
                            <td></td>
                            <td>2-4</td>
                            <td>6-8</td>
                            <td>10-12</td>
                            <td>14-16</td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>Youth (Size) G200B/G240B/G500B</td>
                            <td></td>
                            <td>6-8</td>
                            <td>10-12</td>
                            <td>14-16</td>
                            <td>18-20</td>
                            <td>22-24</td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div v-if="vendor === 'Hanes'">
            <div class="sizeChart">
                <table>
                    <thead>
                        <tr>
                            <th>Gender</th>
                            <th>XXS</th>
                            <th>XS</th>
                            <th>S</th>
                            <th>M</th>
                            <th>L</th>
                            <th>XL</th>
                            <th>2XL</th>
                            <th>3XL</th>
                            <th>4XL</th>
                            <th>5XL</th>
                            <th>6XL</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Men’s (Chest)</td>
                            <td></td>
                            <td>30-32”</td>
                            <td>34-36”</td>
                            <td>38-40”</td>
                            <td>42-44”</td>
                            <td>46-48”</td>
                            <td>50-52”</td>
                            <td>54-56”</td>
                            <td>58-60”</td>
                            <td>62-64”</td>
                            <td>66-68”</td>
                        </tr>
                        <tr>
                            <td>Women’s (Size)</td>
                            <td></td>
                            <td>0-2</td>
                            <td>4-6</td>
                            <td>8-10</td>
                            <td>12-14</td>
                            <td>16-18</td>
                            <td>20-22</td>
                            <td>24-26</td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div v-if="vendor === 'Harriton'">
            <div class="sizeChart">
                <table>
                    <thead>
                        <tr>
                            <th>Gender</th>
                            <th>XXS</th>
                            <th>XS</th>
                            <th>S</th>
                            <th>M</th>
                            <th>L</th>
                            <th>XL</th>
                            <th>2XL</th>
                            <th>3XL</th>
                            <th>4XL</th>
                            <th>5XL</th>
                            <th>6XL</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Men’s (Neck/Collar)</td>
                            <td></td>
                            <td>13.5-14”</td>
                            <td>14.5-15”</td>
                            <td>15.5-16”</td>
                            <td>16.5-17”</td>
                            <td>17.5-18”</td>
                            <td>18.5-19”</td>
                            <td>19.5-20”</td>
                            <td>20.5-21”</td>
                            <td>21.5-22”</td>
                            <td>22.5-23”</td>
                        </tr>
                        <tr>
                            <td>Men’s (Chest)</td>
                            <td></td>
                            <td>32-34”</td>
                            <td>35-38”</td>
                            <td>39-41”</td>
                            <td>42-45”</td>
                            <td>46-49”</td>
                            <td>50-52”</td>
                            <td>53-56”</td>
                            <td>57-60”</td>
                            <td>61-64”</td>
                            <td>65-68”</td>
                        </tr>
                        <tr>
                            <td>Men’s (Waist)</td>
                            <td></td>
                            <td>26-28”</td>
                            <td>29-31”</td>
                            <td>32-34”</td>
                            <td>35-37”</td>
                            <td>38-41”</td>
                            <td>42-44”</td>
                            <td>45-47”</td>
                            <td>48-50”</td>
                            <td>51-53”</td>
                            <td>54-56”</td>
                        </tr>
                        <tr>
                            <td>Women’s (Chest)</td>
                            <td></td>
                            <td>31-32”</td>
                            <td>33-35”</td>
                            <td>36-38”</td>
                            <td>39-42”</td>
                            <td>43-45”</td>
                            <td>46-49”</td>
                            <td>50-53”</td>
                            <td>54-57”</td>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>Women’s (Waist)</td>
                            <td></td>
                            <td>23-24”</td>
                            <td>25-27”</td>
                            <td>28-30”</td>
                            <td>31-32”</td>
                            <td>33-35”</td>
                            <td>36-38”</td>
                            <td>39-41”</td>
                            <td>42-44”</td>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>Women’s (Hip)</td>
                            <td></td>
                            <td>33-34”</td>
                            <td>35-37”</td>
                            <td>38-40”</td>
                            <td>41-42”</td>
                            <td>43-45”</td>
                            <td>46-48”</td>
                            <td>49-51”</td>
                            <td>52-54”</td>
                            <td></td>
                            <td></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div v-if="vendor === 'J America'">
            <div class="sizeChart">
                <table>
                    <thead>
                        <tr>
                            <th>Gender</th>
                            <th>XXS</th>
                            <th>XS</th>
                            <th>S</th>
                            <th>M</th>
                            <th>L</th>
                            <th>XL</th>
                            <th>2XL</th>
                            <th>3XL</th>
                            <th>4XL</th>
                            <th>5XL</th>
                            <th>6XL</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Men’s (Chest)</td>
                            <td>32-35”</td>
                            <td>35-39”</td>
                            <td>40-45”</td>
                            <td>44-48”</td>
                            <td>48-51”</td>
                            <td>50-54”</td>
                            <td>52-57”</td>
                            <td>56-60”</td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>Women’s (Chest)</td>
                            <td></td>
                            <td>28-37”</td>
                            <td>34-39”</td>
                            <td>36-42”</td>
                            <td>38-45”</td>
                            <td>40-48”</td>
                            <td>42-52”</td>
                            <td>44-53”</td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>Unisex (Chest)</td>
                            <td></td>
                            <td>45”</td>
                            <td>47”</td>
                            <td>49”</td>
                            <td>51”</td>
                            <td>53”</td>
                            <td>55”</td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div v-if="vendor === 'Jerzees'">
            <div class="sizeChart">
                <table>
                    <thead>
                        <tr>
                            <th>Gender</th>
                            <th>XXS</th>
                            <th>XS</th>
                            <th>S</th>
                            <th>M</th>
                            <th>L</th>
                            <th>XL</th>
                            <th>2XL</th>
                            <th>3XL</th>
                            <th>4XL</th>
                            <th>5XL</th>
                            <th>6XL</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Men’s (Chest)</td>
                            <td></td>
                            <td></td>
                            <td>34-36”</td>
                            <td>38-40”</td>
                            <td>42-44”</td>
                            <td>46-48”</td>
                            <td>50-52”</td>
                            <td>54-56”</td>
                            <td>58-60”</td>
                            <td>62-64”</td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>Women’s (Size)</td>
                            <td></td>
                            <td></td>
                            <td>4-6</td>
                            <td>8-10</td>
                            <td>12-14</td>
                            <td>16-18</td>
                            <td>20-22</td>
                            <td>24-26</td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>Youth (Size)</td>
                            <td></td>
                            <td>2-4</td>
                            <td>6-8</td>
                            <td>10-12</td>
                            <td>14-16</td>
                            <td>18-20</td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                    </tbody>
                </table>
            </div>

        </div>
        <div v-if="vendor === 'LAT Apparel'">
            <div class="sizeChart">
                <table>
                    <thead>
                        <tr>
                            <th>Gender</th>
                            <th>XXS</th>
                            <th>XS</th>
                            <th>S</th>
                            <th>M</th>
                            <th>L</th>
                            <th>XL</th>
                            <th>2XL</th>
                            <th>3XL</th>
                            <th>4XL</th>
                            <th>5XL</th>
                            <th>6XL</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Men’s (Chest)</td>
                            <td></td>
                            <td></td>
                            <td>34-36”</td>
                            <td>38-40”</td>
                            <td>42-44”</td>
                            <td>46-48”</td>
                            <td>50-52”</td>
                            <td>54-56”</td>
                            <td>58-60”</td>
                            <td>62-64”</td>
                            <td>66-68”</td>
                        </tr>
                        <tr>
                            <td>Women’s (Size)</td>
                            <td></td>
                            <td>0-2</td>
                            <td>204</td>
                            <td>6</td>
                            <td>8-10</td>
                            <td>12-14</td>
                            <td>16-18</td>
                            <td>20-22</td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>Women’s (Chest)</td>
                            <td></td>
                            <td>30-32”</td>
                            <td>32-34”</td>
                            <td>34-36”</td>
                            <td>36-40”</td>
                            <td>40-44”</td>
                            <td>44-48”</td>
                            <td>48-52”</td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div v-if="vendor === 'Next Level Apparel'">
            <div class="sizeChart">
                <table>
                    <thead>
                        <tr>
                            <th>Gender</th>
                            <th>XXS</th>
                            <th>XS</th>
                            <th>S</th>
                            <th>M</th>
                            <th>L</th>
                            <th>XL</th>
                            <th>2XL</th>
                            <th>3XL</th>
                            <th>4XL</th>
                            <th>5XL</th>
                            <th>6XL</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Men’s/Unisex (Chest)</td>
                            <td></td>
                            <td>33-35”</td>
                            <td>35-38”</td>
                            <td>38-41”</td>
                            <td>43-44”</td>
                            <td>45-48”</td>
                            <td>48-52”</td>
                            <td>53.5-56”</td>
                            <td>60”</td>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>Women’s Fitted (Size)</td>
                            <td></td>
                            <td></td>
                            <td>0-2</td>
                            <td>2-4</td>
                            <td>4-6</td>
                            <td>8-10</td>
                            <td>12</td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>Women’s Relaxed (Size)</td>
                            <td></td>
                            <td>0-2</td>
                            <td>2-4</td>
                            <td>4-6</td>
                            <td>8-10</td>
                            <td>12-14</td>
                            <td>14-16</td>
                            <td>18-20</td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>Toddler (Size)</td>
                            <td></td>
                            <td>2T</td>
                            <td>3T</td>
                            <td>4T</td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div v-if="vendor === 'North End'">
            <div class="sizeChart">
                <table>
                    <thead>
                        <tr>
                            <th>Gender</th>
                            <th>XXS</th>
                            <th>XS</th>
                            <th>S</th>
                            <th>M</th>
                            <th>L</th>
                            <th>XL</th>
                            <th>2XL</th>
                            <th>3XL</th>
                            <th>4XL</th>
                            <th>5XL</th>
                            <th>6XL</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Men’s (Neck/Collar)</td>
                            <td></td>
                            <td>13.5-14”</td>
                            <td>14.5-15”</td>
                            <td>15.5-16”</td>
                            <td>16.5-17”</td>
                            <td>17.5-18”</td>
                            <td>18.5-19”</td>
                            <td>19.5-20”</td>
                            <td>20.5-21”</td>
                            <td>21.5-22”</td>
                            <td>22.5-23”</td>
                        </tr>
                        <tr>
                            <td>Men’s (Chest)</td>
                            <td></td>
                            <td>32-34”</td>
                            <td>35-38”</td>
                            <td>39-41”</td>
                            <td>42-45”</td>
                            <td>46-49”</td>
                            <td>50-52”</td>
                            <td>53-56”</td>
                            <td>57-60”</td>
                            <td>61-64”</td>
                            <td>65-68”</td>
                        </tr>
                        <tr>
                            <td>Men’s (Waist)</td>
                            <td></td>
                            <td>26-28”</td>
                            <td>29-31”</td>
                            <td>32-34”</td>
                            <td>35-37”</td>
                            <td>38-41”</td>
                            <td>42-44”</td>
                            <td>45-47”</td>
                            <td>48-50”</td>
                            <td>51-53”</td>
                            <td>54-56”</td>
                        </tr>
                        <tr>
                            <td>Women’s (Chest)</td>
                            <td></td>
                            <td>31-32”</td>
                            <td>33-35”</td>
                            <td>36-38”</td>
                            <td>39-42”</td>
                            <td>43-45”</td>
                            <td>46-49”</td>
                            <td>50-53”</td>
                            <td>54-57”</td>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>Women’s (Waist)</td>
                            <td></td>
                            <td>23-24”</td>
                            <td>25-27”</td>
                            <td>28-30”</td>
                            <td>31-32”</td>
                            <td>33-35”</td>
                            <td>36-38”</td>
                            <td>39-41”</td>
                            <td>42-44”</td>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>Women’s (Hip)</td>
                            <td></td>
                            <td>33-34”</td>
                            <td>35-37”</td>
                            <td>38-40”</td>
                            <td>41-42”</td>
                            <td>43-45”</td>
                            <td>46-48”</td>
                            <td>49-51”</td>
                            <td>52-54”</td>
                            <td></td>
                            <td></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div v-if="vendor === 'Puma'">
            <div class="sizeChart">
                <table>
                    <thead>
                        <tr>
                            <th>Gender</th>
                            <th>XXS</th>
                            <th>XS</th>
                            <th>S</th>
                            <th>M</th>
                            <th>L</th>
                            <th>XL</th>
                            <th>2XL</th>
                            <th>3XL</th>
                            <th>4XL</th>
                            <th>5XL</th>
                            <th>6XL</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Men’s Polos (Chest)</td>
                            <td>37”</td>
                            <td>39.5”</td>
                            <td>42”</td>
                            <td>44”</td>
                            <td>47”</td>
                            <td>50.5”</td>
                            <td>53.5”</td>
                            <td>56.5”</td>
                            <td>60”</td>
                            <td>63”</td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>Men’s Layering (Chest)</td>
                            <td>37”</td>
                            <td>39.5”</td>
                            <td>41.5”</td>
                            <td>44”</td>
                            <td>47”</td>
                            <td>50.5”</td>
                            <td>53.5”</td>
                            <td>56.5”</td>
                            <td>60”</td>
                            <td>63”</td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>Women’s Polos (Chest)</td>
                            <td>32.5”</td>
                            <td>34”</td>
                            <td>35.5”</td>
                            <td>37.5”</td>
                            <td>40”</td>
                            <td>41”</td>
                            <td>43.5”</td>
                            <td>46”</td>
                            <td>48.5”</td>
                            <td>51”</td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>Women’s Layering (Chest)</td>
                            <td>32.5”</td>
                            <td>34”</td>
                            <td>36”</td>
                            <td>38”</td>
                            <td>40”</td>
                            <td>42”</td>
                            <td>44”</td>
                            <td>46.5”</td>
                            <td>49”</td>
                            <td>51”</td>
                            <td></td>
                        </tr>
                    </tbody>
                </table>
            </div>

        </div>
        <div v-if="vendor === 'Rabbit Skins'">
            <div class="sizeChart">
                <table>
                    <thead>
                        <tr>
                            <th>Gender</th>
                            <th>XXS</th>
                            <th>XS</th>
                            <th>S</th>
                            <th>M</th>
                            <th>L</th>
                            <th>XL</th>
                            <th>2XL</th>
                            <th>3XL</th>
                            <th>4XL</th>
                            <th>5XL</th>
                            <th>6XL</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Toddler (Size)</td>
                            <td></td>
                            <td></td>
                            <td>2</td>
                            <td>3</td>
                            <td>4</td>
                            <td>5/6</td>
                            <td>7</td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>Infant (Size)</td>
                            <td></td>
                            <td>NB</td>
                            <td>6M</td>
                            <td>12M</td>
                            <td>18M</td>
                            <td>24M</td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div v-if="vendor === 'Sublivie'">
            <div class="sizeChart">
                <table>
                    <thead>
                        <tr>
                            <th>Gender</th>
                            <th>XXS</th>
                            <th>XS</th>
                            <th>S</th>
                            <th>M</th>
                            <th>L</th>
                            <th>XL</th>
                            <th>2XL</th>
                            <th>3XL</th>
                            <th>4XL</th>
                            <th>5XL</th>
                            <th>6XL</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Men’s (Chest)</td>
                            <td></td>
                            <td></td>
                            <td>34-36”</td>
                            <td>38-40”</td>
                            <td>42-44”</td>
                            <td>46-48”</td>
                            <td>50-52”</td>
                            <td>54-56”</td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div v-if="vendor === 'Team 365'">
            <div class="sizeChart">
                <table>
                    <thead>
                        <tr>
                            <th>Gender</th>
                            <th>XXS</th>
                            <th>XS</th>
                            <th>S</th>
                            <th>M</th>
                            <th>L</th>
                            <th>XL</th>
                            <th>2XL</th>
                            <th>3XL</th>
                            <th>4XL</th>
                            <th>5XL</th>
                            <th>6XL</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Men’s (Neck/Collar)</td>
                            <td></td>
                            <td>13.5-14”</td>
                            <td>14.5-15”</td>
                            <td>15.5-16”</td>
                            <td>16.5-17”</td>
                            <td>17.5-18”</td>
                            <td>18.5-19”</td>
                            <td>19.5-20”</td>
                            <td>20.5-21”</td>
                            <td>21.5-22”</td>
                            <td>22.5-23”</td>
                        </tr>
                        <tr>
                            <td>Men’s (Chest)</td>
                            <td></td>
                            <td>32-34”</td>
                            <td>35-38”</td>
                            <td>39-41”</td>
                            <td>42-45”</td>
                            <td>46-49”</td>
                            <td>50-52”</td>
                            <td>53-56”</td>
                            <td>57-60”</td>
                            <td>61-64”</td>
                            <td>65-68”</td>
                        </tr>
                        <tr>
                            <td>Men’s (Waist)</td>
                            <td></td>
                            <td>26-28”</td>
                            <td>29-31”</td>
                            <td>32-34”</td>
                            <td>35-37”</td>
                            <td>38-41”</td>
                            <td>42-44”</td>
                            <td>45-47”</td>
                            <td>48-50”</td>
                            <td>51-53”</td>
                            <td>54-56”</td>
                        </tr>
                        <tr>
                            <td>Women’s (Chest)</td>
                            <td></td>
                            <td>31-32”</td>
                            <td>33-35”</td>
                            <td>36-38”</td>
                            <td>39-42”</td>
                            <td>43-45”</td>
                            <td>46-49”</td>
                            <td>50-53”</td>
                            <td>54-57”</td>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>Women’s (Waist)</td>
                            <td></td>
                            <td>23-24”</td>
                            <td>25-27”</td>
                            <td>28-30”</td>
                            <td>31-32”</td>
                            <td>33-35”</td>
                            <td>36-38”</td>
                            <td>39-41”</td>
                            <td>42-44”</td>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>Women’s (Hip)</td>
                            <td></td>
                            <td>33-34”</td>
                            <td>35-37”</td>
                            <td>38-40”</td>
                            <td>41-42”</td>
                            <td>43-45”</td>
                            <td>46-48”</td>
                            <td>49-51”</td>
                            <td>52-54”</td>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>Youth (Chest)</td>
                            <td></td>
                            <td>24-25”</td>
                            <td>26-27”</td>
                            <td>28-30”</td>
                            <td>31-32”</td>
                            <td>33-34”</td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>Youth (Waist)</td>
                            <td></td>
                            <td>21-22”</td>
                            <td>23-24”</td>
                            <td>25-26”</td>
                            <td>27-28”</td>
                            <td>29-30”</td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div v-if="vendor === 'The Artisan'">
            <div class="sizeChart">
                <table>
                    <thead>
                        <tr>
                            <th>Gender</th>
                            <th>XXS</th>
                            <th>XS</th>
                            <th>S</th>
                            <th>M</th>
                            <th>L</th>
                            <th>XL</th>
                            <th>2XL</th>
                            <th>3XL</th>
                            <th>4XL</th>
                            <th>5XL</th>
                            <th>6XL</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Men’s (Chest)</td>
                            <td></td>
                            <td>34-36”</td>
                            <td>36-38”</td>
                            <td>38-40”</td>
                            <td>42-44”</td>
                            <td>46-48”</td>
                            <td>50-52”</td>
                            <td>54-56”</td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>Women’s (Size)</td>
                            <td></td>
                            <td>32-34”</td>
                            <td>34-36”</td>
                            <td>36-38”</td>
                            <td>38-40”</td>
                            <td>40-42”</td>
                            <td>42-44”</td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>Unisex Chef’s Pants</td>
                            <td></td>
                            <td>28-30”</td>
                            <td>32-34”</td>
                            <td>34-36”</td>
                            <td>36-38”</td>
                            <td>38-40”</td>
                            <td>42-44”</td>
                            <td>44-46”</td>
                            <td>46-48”</td>
                            <td></td>
                            <td></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div v-if="vendor === 'Threadfast'">
            <div class="sizeChart">
                <table>
                    <thead>
                        <tr>
                            <th>Gender</th>
                            <th>XXS</th>
                            <th>XS</th>
                            <th>S</th>
                            <th>M</th>
                            <th>L</th>
                            <th>XL</th>
                            <th>2XL</th>
                            <th>3XL</th>
                            <th>4XL</th>
                            <th>5XL</th>
                            <th>6XL</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Men’s/Unisex (Chest)</td>
                            <td></td>
                            <td>30-32”</td>
                            <td>34-36”</td>
                            <td>38-40”</td>
                            <td>42-44”</td>
                            <td>46-48”</td>
                            <td>50-52”</td>
                            <td>54-56”</td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>Joggers (Inseam)</td>
                            <td></td>
                            <td>27.5”</td>
                            <td>28”</td>
                            <td>28.5”</td>
                            <td>29”</td>
                            <td>29.5”</td>
                            <td>30”</td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>Joggers (Waist)</td>
                            <td></td>
                            <td>28”</td>
                            <td>30”</td>
                            <td>32”</td>
                            <td>34”</td>
                            <td>36”</td>
                            <td>38”</td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>Yoga Pants (Inseam)</td>
                            <td></td>
                            <td>24.25”</td>
                            <td>24.75”</td>
                            <td>25.25”</td>
                            <td>25.75”</td>
                            <td>26.25”</td>
                            <td>26.75”</td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>Yoga Pants (Waist)</td>
                            <td></td>
                            <td>18”</td>
                            <td>20”</td>
                            <td>22”</td>
                            <td>24”</td>
                            <td>26”</td>
                            <td>28”</td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div v-if="vendor === 'Tie-Dye'">
            <div class="sizeChart">
                <table>
                    <thead>
                        <tr>
                            <th>Gender</th>
                            <th>XXS</th>
                            <th>XS</th>
                            <th>S</th>
                            <th>M</th>
                            <th>L</th>
                            <th>XL</th>
                            <th>2XL</th>
                            <th>3XL</th>
                            <th>4XL</th>
                            <th>5XL</th>
                            <th>6XL</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Unisex (Chest)</td>
                            <td></td>
                            <td></td>
                            <td>34-36”</td>
                            <td>38-40”</td>
                            <td>42-44”</td>
                            <td>46-48”</td>
                            <td>50-52”</td>
                            <td>54-56”</td>
                            <td>58-60”</td>
                            <td>62-64”</td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>Joggers (Waist)</td>
                            <td></td>
                            <td></td>
                            <td>30”</td>
                            <td>32”</td>
                            <td>34”</td>
                            <td>36”</td>
                            <td>38”</td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>Joggers (Inseam)</td>
                            <td></td>
                            <td></td>
                            <td>29”</td>
                            <td>30”</td>
                            <td>31”</td>
                            <td>32”</td>
                            <td>33”</td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>Joggers (Outseam)</td>
                            <td></td>
                            <td></td>
                            <td>39”</td>
                            <td>40”</td>
                            <td>41”</td>
                            <td>42”</td>
                            <td>43”</td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div v-if="vendor === 'Ultraclub'">
            <div class="sizeChart">
                <table>
                    <thead>
                        <tr>
                            <th>Gender</th>
                            <th>XXS</th>
                            <th>XS</th>
                            <th>S</th>
                            <th>M</th>
                            <th>L</th>
                            <th>XL</th>
                            <th>2XL</th>
                            <th>3XL</th>
                            <th>4XL</th>
                            <th>5XL</th>
                            <th>6XL</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Men’s (Neck/Collar)</td>
                            <td></td>
                            <td>13.5-14”</td>
                            <td>14.5-15”</td>
                            <td>15.5-16”</td>
                            <td>16.5-17”</td>
                            <td>17.5-18”</td>
                            <td>18.5-19”</td>
                            <td>19.5-20”</td>
                            <td>20.5-21”</td>
                            <td>21.5-22”</td>
                            <td>22.5-23”</td>
                        </tr>
                        <tr>
                            <td>Men’s (Chest)</td>
                            <td></td>
                            <td>32-34”</td>
                            <td>35-38”</td>
                            <td>39-41”</td>
                            <td>42-45”</td>
                            <td>46-49”</td>
                            <td>50-52”</td>
                            <td>53-56”</td>
                            <td>57-60”</td>
                            <td>61-64”</td>
                            <td>65-68”</td>
                        </tr>
                        <tr>
                            <td>Men’s (Waist)</td>
                            <td></td>
                            <td>26-28”</td>
                            <td>29-31”</td>
                            <td>32-34”</td>
                            <td>35-37”</td>
                            <td>38-41”</td>
                            <td>42-44”</td>
                            <td>45-47”</td>
                            <td>48-50”</td>
                            <td>51-53”</td>
                            <td>54-56”</td>
                        </tr>
                        <tr>
                            <td>Women’s (Chest)</td>
                            <td></td>
                            <td>31-32”</td>
                            <td>33-35”</td>
                            <td>36-38”</td>
                            <td>39-42”</td>
                            <td>43-45”</td>
                            <td>46-49”</td>
                            <td>50-53”</td>
                            <td>54-57”</td>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>Women’s (Waist)</td>
                            <td></td>
                            <td>23-24”</td>
                            <td>25-27”</td>
                            <td>28-30”</td>
                            <td>31-32”</td>
                            <td>33-35”</td>
                            <td>36-38”</td>
                            <td>39-41”</td>
                            <td>42-44”</td>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>Women’s (Hip)</td>
                            <td></td>
                            <td>33-34”</td>
                            <td>35-37”</td>
                            <td>38-40”</td>
                            <td>41-42”</td>
                            <td>43-45”</td>
                            <td>46-48”</td>
                            <td>49-51”</td>
                            <td>52-54”</td>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>Youth (Chest)</td>
                            <td></td>
                            <td>24-25”</td>
                            <td>26-27”</td>
                            <td>28-30”</td>
                            <td>31-32”</td>
                            <td>33-34”</td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>Youth (Waist)</td>
                            <td></td>
                            <td>21-22”</td>
                            <td>23-24”</td>
                            <td>25-26”</td>
                            <td>27-28”</td>
                            <td>29-30”</td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "SizeChart",
    props: {
        vendor: String,
    }
}
</script>
<style scoped>
.sizeChart {
    overflow: auto;
    width: 100%;
}

.sizeChart table {
    border: 1px solid #DEDEDF;
    height: 100%;
    width: 100%;
    table-layout: auto;
    border-collapse: collapse;
    border-spacing: 1px;
    text-align: left;
}

.sizeChart caption {
    caption-side: top;
    text-align: left;
}

.sizeChart th {
    border: 1px solid #DEDEDF;
    background-color: #ECEFF1;
    color: #000000;
    padding: 5px;
}

.sizeChart td {
    border: 1px solid #DEDEDF;
    background-color: #FFFFFF;
    color: #000000;
    padding: 3px;
    font-size: 11px;
}
</style>